import { useEffect, useState } from "react";
import type { DMCScanner } from "~/features/scanDmc/components/DMCScanPage/DMCScanner/DMCScanner";

export const useDMCScanner = (props: { oneCodeImplUrl?: string } = {}) => {
  const { oneCodeImplUrl } = props;
  const [loading, setLoading] = useState(true);
  const [scanner, setScanner] = useState<DMCScanner | null>(null);

  useEffect(() => {
    (async () => {
      const module = await import("./DMCScanner");
      const scanner = module.createDMCScanner(
        oneCodeImplUrl ? oneCodeImplUrl + "/" : undefined,
        oneCodeImplUrl ? oneCodeImplUrl + "/model.onnx" : undefined,
      );
      scanner.onReady().then(() => {
        setScanner(scanner);
        setLoading(false);
      });
    })();
  }, [oneCodeImplUrl]);

  if (loading) {
    return {
      loading: true,
      scanner: null,
    } as const;
  } else {
    return {
      loading: false,
      scanner: scanner!,
    } as const;
  }
};
